import { render } from "./sketch.vue?vue&type=template&id=9f7b84d6"
import script from "./sketch.vue?vue&type=script&lang=js"
export * from "./sketch.vue?vue&type=script&lang=js"

import "./sketch.vue?vue&type=style&index=0&id=9f7b84d6&lang=scss"

import exportComponent from "C:\\Users\\86134\\Desktop\\Web\\Item\\来画设计\\laiiva-web\\packages\\QColor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__